import { connect } from 'react-redux';
import { AppState } from '../../store/store';
import { Live } from './components/Live/Live';
import { actions } from './liveSlice';
import { LiveComment } from './models/liveComment';
import { LiveMember } from './models/liveMember';
import { ResponseUser } from '../../services/api/models/response/responseUser';
import { MediaDevice } from './components/LiveSettings/LiveSettings';
import {
  ResponseJoinLive,
  ResponseLiveInfo,
} from '../../services/api/models/response/responseLive';
import { ClientRole } from 'agora-rtc-sdk-ng';
import { RtcEngine } from '../../services/agora/rtcEngine';
import { RtmEngine } from '../../services/agora/rtmEngine';
import { ResponseAudience } from '../../services/api/models/response/responseAudience';
import { ResponseBoard } from '../../services/api/models/response/responseBoard';
import { MessageUser } from './models/messageUser';
import { ResponseEvent } from '../../services/api/models/response/responseEvent';
import {
  IResponseUserPairData,
  ResponseUserPairWantJoined,
} from '../../services/api/models/response/responseVoicePlus';

export interface LiveProps {
  liveState: LiveState;
  toggleTermModal: (isShow: boolean) => void;
  toggleGuidelineModal: (isShow: boolean) => void;
  toggleSettingsModal: (isShow: boolean) => void;
  updateListMediaDevices: (mediaDevices: Array<MediaDevice>) => void;
  changeVideoInput: (device: string | undefined) => void;
  changeAudioInput: (device: string) => void;
  changeAudioOutput: (device: string) => void;
  startLive: (data: ResponseLiveInfo) => void;
  joinLive: (data: ResponseJoinLive) => void;
  addLiveComment: (comment: LiveComment) => void;
  resetLiveData: () => void;
  endLive: () => void;
  toggleMirrorMode: () => void;
  toggleAudio: () => void;
  setGiftTopAudience: (audience: ResponseAudience | undefined) => void;
  showListBoard: (isShow: boolean) => void;
  updateLiveBoard: (board: ResponseBoard) => void;
  deleteLiveBoard: () => void;
  updateLiverLevel: (user: MessageUser) => void;
  showEventModal: (event: ResponseEvent | undefined) => void;
  toggleMissionModal: (isShow: boolean) => void;
  toggleVoiceGuestModal: (isShow: boolean) => void;
  toggleSettingPairModal: (isShow: boolean) => void;
  reloadMissionGiftTab: () => void;
  changeAcceptPair: (isChange: boolean) => void;
  handleChangePairType: (type: string | undefined) => void;
  handleDisableButtonRequest: (isDisable: boolean) => void;
  updateListPair: (list: Array<ResponseUserPairWantJoined>) => void;
  updateUserPair: (user?: IResponseUserPairData | any) => void;
  showAllowChoicePair: (isShow: boolean) => void;
  handleChangeButtonRequest: (isChange: boolean) => void;
  toggleRemoveUserPairModal: (isShow: boolean) => void;
  toggleNoticeApprovePairModal: (isShow: boolean) => void;
  updateListMediaDevicesGuest: (mediaDevices: Array<MediaDevice>) => void;
  changeAudioInputGuest: (device: string) => void;
  toggleProfileModal: (isShow: boolean) => void;
  toggleConfirmBlockedModal: (isShow: boolean) => void;
}

export interface LiveState {
  rtcEngine?: RtcEngine;
  rtmEngine?: RtmEngine;
  liveData?: ResponseLiveInfo;
  role: ClientRole;
  isEnded: boolean;
  isLive: boolean;
  joinId: string;

  mediaDevices: Array<MediaDevice>;
  inputVideoDevice?: string | undefined;
  inputAudioDevice?: string;
  outputAudioDevice?: string;

  // modal
  isShowTermModal: boolean;
  isShowGuidelineModal: boolean;
  isShowSettingModal: boolean;
  isShowVoiceGuestModal?: boolean;
  isShowSettingPairModal?: boolean;
  isInLive: boolean;
  isShowAllowChoice?: boolean;
  isShowRemoveUserPairModal: boolean;
  isShowNoticePairModal: boolean;

  // events
  name?: string;
  eventId?: string;
  subEventId?: string;
  liveCategoryId?: string;
  showEventModal: boolean;
  currentShowEvent?: ResponseEvent;

  // user
  userData?: ResponseUser;
  isLogin: boolean;
  liverLv: number;
  giftTopAudience?: ResponseUser;
  userCoin?: number;
  isShowProfileModal?: boolean;
  isShowConfirmBlockedModal?: boolean;

  // diamond
  gottenDiamond: number;
  gottenDiamondPool: number;
  isDiamondAnim: boolean;

  // member
  memberLastestUpdate: number;
  channelMemberList: Array<LiveMember>;
  liveComments: Array<LiveComment>;

  // settings
  isAudioMuted: boolean;
  isMirrorEnable: boolean;

  // board
  isShowListBoard: boolean;

  // missions
  isShowMissionModal: boolean;
  isReloadingMissionGiftTab?: boolean;
  //pair
  isSendRequestPair: boolean;
  isAcceptPair: boolean;
  listPair: Array<ResponseUserPairWantJoined>;
  userPair?: IResponseUserPairData;
  pairType?: string;
  mediaDevicesGuest: Array<MediaDevice>;
  inputAudioDeviceGuest?: string;
}

const mapStateToProps = (state: AppState) => ({
  liveState: state.live,
});

const mapDispatchToProps = {
  toggleTermModal: actions.toggleTermModal,
  toggleGuidelineModal: actions.toggleGuidelineModal,
  toggleSettingsModal: actions.toggleSettingsModal,
  updateListMediaDevices: actions.updateListMediaDevices,
  changeVideoInput: actions.changeVideoInput,
  changeAudioInput: actions.changeAudioInput,
  changeAudioOutput: actions.changeAudioOutput,
  startLive: actions.startLive,
  joinLive: actions.joinLive,
  addLiveComment: actions.addLiveComment,
  resetLiveData: actions.resetLiveData,
  endLive: actions.endLive,
  toggleAudio: actions.toggleAudio,
  toggleMirrorMode: actions.toggleMirrorMode,
  setGiftTopAudience: actions.setGiftTopAudience,
  showListBoard: actions.showListBoard,
  updateLiveBoard: actions.updateLiveBoard,
  deleteLiveBoard: actions.deleteLiveBoard,
  updateLiverLevel: actions.updateLiverLevel,
  showEventModal: actions.showEventModal,
  toggleMissionModal: actions.toggleMissionModal,
  toggleVoiceGuestModal: actions.toggleVoiceGuestModal,
  toggleSettingPairModal: actions.toggleSettingPairModal,
  reloadMissionGiftTab: actions.reloadMissionGiftTab,
  changeAcceptPair: actions.changeAcceptPair,
  handleChangePairType: actions.handleChangePairType,
  handleDisableButtonRequest: actions.handleDisableButtonRequest,
  updateListPair: actions.updateListPair,
  updateUserPair: actions.updateUserPair,
  showAllowChoicePair: actions.showAllowChoicePair,
  handleChangeButtonRequest: actions.handleChangeButtonRequest,
  toggleRemoveUserPairModal: actions.toggleRemoveUserPairModal,
  toggleNoticeApprovePairModal: actions.toggleNoticeApprovePairModal,
  updateListMediaDevicesGuest: actions.updateListMediaDevicesGuest,
  changeAudioInputGuest: actions.changeAudioInputGuest,
  toggleProfileModal: actions.toggleProfileModal,
  toggleConfirmBlockedModal: actions.toggleConfirmBlockedModal,
};

export const LiveContainer = {
  live: connect(mapStateToProps, mapDispatchToProps)(Live),
};
